import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import MapService from '../../../services/mapService';
import SocketMixin from '../../../components/core/dtwin/socketMixin';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import cloneDeep from 'lodash/cloneDeep';
const localStorageKey = 'is-warnapp-dtwin-id';
export default {
  name: 'ViewISWarnappViewer',
  mixins: [SocketMixin],
  data: function () {
    return {
      // if a twin has been selected before and is loaded from the local-storage on page-load,
      // there is no user-interaction which is required for the audio-player
      // thus, show a big button on the screen to "start" the monitor
      showInitialInteractionButton: true,
      dummyAudioInterval: null,
      treeMenu: false,
      treeMenuPosition: {},
      soundIsMuted: false,
      selectedDtwin: {},
      dtwinAncestors: {},
      warnState: {},
      alarmHigh: null,
      alarmLow: null,
      statusConfigs: {
        good: {
          key: 'good',
          label: this.$i18n_t('IS.Warnapp.good'),
          // img: 'img/modules/is-warnapp/thumbsup.png',
          icon: 'fal fa-check-square',
          bgColor: 'rgba(0, 180, 0)'
        },
        okay: {
          key: 'okay',
          label: this.$i18n_t('IS.Warnapp.okay'),
          // img: 'img/modules/is-warnapp/okay.jpg',
          icon: 'fal fa-hand-lizard',
          bgColor: 'rgba(230, 200, 10)'
        },
        bad: {
          key: 'bad',
          label: this.$i18n_t('IS.Warnapp.bad'),
          // img: 'img/modules/is-warnapp/motherofgod.png',
          icon: 'fal fa-thumbs-down',
          bgColor: 'rgba(180, 0, 0)'
        },
        unknown: {
          key: 'unknown',
          label: this.$i18n_t('IS.Warnapp.unknown'),
          img: 'img/modules/is-warnapp/shoulder.jpg',
          bgColor: 'rgba(80, 80, 80)'
        }
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    mode() {
      return this.UiTheme ? 'dark' : 'light';
    },
    opacity() {
      return this.UiTheme ? '0.6' : '0.85';
    },
    homeLink() {
      return this.$store.state.app.sidebarIconLink || '/home';
    },
    formattedStateValue() {
      const currentValue = parseFloat(get(this.warnState, 'value.value'));
      const visualOptions = get(this.warnState, 'properties.visual.options');
      if (!isNaN(currentValue) && visualOptions && get(this.warnState, 'properties.visual.type') === 'gauge' && get(this.warnState, 'properties.valueType') === 'number') {
        return `(${Math.round(currentValue)} ${this.warnState.properties.unit})`;
      }
      return null;
    },
    audioPath() {
      const raiseTheRoof = this.statusDetails.key === 'bad';
      this.$nextTick(() => {
        const player = this.$refs['alarm-player'];
        if (player && !this.showInitialInteractionButton) {
          navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
          if (raiseTheRoof) {
            player.play();

            // optionally, vibrate if the device supports it
            if (navigator.vibrate) {
              // 3 vibration bursts with 1s pause between
              navigator.vibrate([500, 1000, 500, 1000, 500]);
            }
          } else {
            player.pause();
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            player.currentTime = 0.0;
            if (navigator.vibrate) {
              navigator.vibrate(0);
            }
          }
        }
      });
      return this.alarmAudioUrl;
    },
    statusDetails() {
      const currentValue = parseFloat(get(this.warnState, 'value.value'));
      const visualOptions = get(this.warnState, 'properties.visual.options');
      if (!isNaN(currentValue) && visualOptions && get(this.warnState, 'properties.visual.type') === 'gauge' && get(this.warnState, 'properties.valueType') === 'number') {
        const currentValue = parseFloat(this.warnState.value.value);
        let quality = 'unknown';
        let highValue = parseFloat(visualOptions.min) + (parseFloat(visualOptions.max) - parseFloat(visualOptions.min)) * 0.66;
        let lowValue = parseFloat(visualOptions.min) + (parseFloat(visualOptions.max) - parseFloat(visualOptions.min)) * 0.33;
        if (this.alarmHigh) {
          highValue = parseFloat(this.alarmHigh.value.value);
        }
        if (this.alarmLow) {
          lowValue = parseFloat(this.alarmLow.value.value);
        }
        quality = currentValue <= lowValue ? 'good' : currentValue > highValue ? 'bad' : 'okay';
        let bgColor = this.statusConfigs[quality].bgColor;
        // find the threshold-index for the actual color from the gauge-config
        const thresholds = get(visualOptions, 'thresholds', '').split(',').map(v => parseFloat(v));
        const sortedThresholds = cloneDeep(thresholds).sort((a, b) => a - b);
        // find the first threshold in the sorted list that is smaller than the current value
        let nextSmallerThreshold = parseFloat(visualOptions.max);
        for (let i = 0; i < sortedThresholds.length; i++) {
          if (sortedThresholds[i] >= currentValue) {
            break;
          }
          nextSmallerThreshold = sortedThresholds[i];
        }
        const tIndex = thresholds.indexOf(nextSmallerThreshold);
        // if not found, will use the first color, which maps to "min"
        bgColor = visualOptions.thresColors[tIndex + 1];
        return {
          ...this.statusConfigs[quality],
          bgColor
        };
      }
      return this.statusConfigs['unknown'];
    },
    logoUrl() {
      return this.findAncestorAttachment(get(this.selectedDtwin, 'id'), /^warnapp_logo\.(jp(e?)g|png|gif)$/i);
    },
    alarmAudioUrl() {
      return this.findAncestorAttachment(get(this.selectedDtwin, 'id'), /^warnapp_alarm\.(o(pus|g([gax]{1}))|spx|webm|mp3|(fl|a)ac|wav(e?))$/i) || 'img/modules/is-warnapp/alarm.mp3';
    }
  },
  watch: {
    soundIsMuted() {
      this.$nextTick(() => {
        const player = this.$refs['alarm-player'];
        if (player) {
          player.volume = this.soundIsMuted ? 0 : 1;
        }
      });
    },
    showInitialInteractionButton() {
      this.warnState = cloneDeep(this.warnState);
    }
  },
  destroyed() {
    if (this.dummyAudioInterval) {
      clearTimeout(this.dummyAudioInterval);
    }
  },
  created() {
    const dtwinId = localStorage.getItem(localStorageKey);
    if (dtwinId) {
      ApiService.digitalTwinGet(this, dtwinId).then(data => {
        this.digitalTwinSelected(data);
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.digitalTwins.twinNotFound'), 'error');
        }
      });
    }
  },
  methods: {
    get,
    playDummyAudio(scope) {
      // setTimeout-handling requires the "scope" to be handed over as parameter
      // for the first time calling there is no scope yet, it is the original vue-component
      const instance = scope || this;
      instance.$nextTick(() => {
        const dummyPlayer = instance.$refs['dummy-audio'];
        dummyPlayer.play();
      });
      instance.dummyAudioInterval = setTimeout(instance.playDummyAudio, 30 * 1000, instance);
    },
    mixedColorForValue(visualOptions, stateValue) {
      let values = [parseFloat(visualOptions.min)].concat(visualOptions.thresholds.split(',').map(t => parseFloat(t)));
      let index = 0;
      for (let i = 0; i < values.length; i++) {
        if (values[i] < stateValue) {
          break;
        }
      }
      let bgColor = MapService.convertToRgba(visualOptions.thresColors[index], 0.35);
      if (index !== values.length - 1) {
        let colors = [visualOptions.thresColors[index], visualOptions.thresColors[index + 1]];
        const mix = (stateValue - values[index]) / (values[index + 1] - values[index]);
        bgColor = MapService.mixRgbaColor(colors[0], colors[1], mix);
      }
      return bgColor;
    },
    findTwinInTree(dtwinId, list = undefined) {
      if (!dtwinId) {
        return null;
      }
      const searching = list || get(this.dtwinAncestors, 'digitaltwins') || [];
      for (let i = 0; i < searching.length; i++) {
        if (searching[i].id === dtwinId) {
          return searching[i];
        } else {
          let foundTwin = this.findTwinInTree(dtwinId, get(searching[i], 'children', []));
          if (foundTwin) {
            return foundTwin;
          }
        }
      }
      return null;
    },
    findAncestorAttachment(dtwinId, regex) {
      if (!dtwinId) {
        return null;
      }
      let twinObject = {};
      if (dtwinId === this.selectedDtwin.id) {
        twinObject = this.selectedDtwin;
      } else {
        twinObject = this.findTwinInTree(dtwinId);
      }
      const attachments = get(twinObject, 'data.attachments', []);
      const matchAttachment = attachments.find(a => regex.test(a.name));
      if (matchAttachment) {
        return `${process.env.VUE_APP_API_HOST}${process.env.VUE_APP_API_PATH}/upload/${matchAttachment.id}`;
      }
      return this.findAncestorAttachment(get(twinObject, 'parentId'), regex);
    },
    doOpenTree(e) {
      e.preventDefault();
      this.showInitialInteractionButton = false;
      this.treeMenuPosition = {
        x: e.clientX,
        y: e.clientY
      };
      this.treeMenu = true;
    },
    digitalTwinFilter(item) {
      if (isArray(get(item, 'data.tags', []))) {
        return get(item, 'data.tags', []).findIndex(t => t.toLowerCase() === 'warnapp-sensor') >= 0;
      }
      return false;
    },
    digitalTwinSelected(e) {
      // NOTE: the tree emits the selection of a twin right after startup
      // this would lead to the tree never really opening, if the already selected twin is emitted again
      // so in that case, ignore the emission as nothing changes
      if (e && this.selectedDtwin && e.id === this.selectedDtwin.id) {
        return;
      }
      localStorage.setItem(localStorageKey, get(e, 'id'));
      this.selectedDtwin = e || {};
      this.treeMenu = false;
      if (this.selectedDtwin.id) {
        this.loadStates();
      } else {
        this.warnState = undefined;
      }
    },
    loadStates() {
      Promise.all([ApiService.digitalTwinFetchPartialTree(this, this.selectedDtwin.parentId, undefined, undefined, ['no-children']), ApiService.digitalTwinFetchStates(this, this.selectedDtwin.id)]).then(states => {
        this.dtwinAncestors = states[0];
        this.warnState = states[1].find(s => s.key.toLowerCase() === 'warnapp_gauge');
        this.alarmHigh = states[1].find(s => s.key.toLowerCase() === 'warnapp_alarm_high');
        this.alarmLow = states[1].find(s => s.key.toLowerCase() === 'warnapp_alarm_low');
        if (this.warnState) {
          this.setupDtwinSocket(this.selectedDtwin.id);
        }
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.digitalTwins.errorFindingDTwins'), 'error');
        }
      });
    },
    statesValuesUpdated(statesData) {
      const matchWarnState = statesData.find(s => s.id === this.warnState.id);
      if (matchWarnState) {
        this.warnState.value.value = matchWarnState.value;
        this.warnState = cloneDeep(this.warnState);
      }
      const matchAlarmHighState = statesData.find(s => s.id === get(this.alarmHigh, 'id'));
      if (matchAlarmHighState) {
        this.alarmHigh.value.value = matchAlarmHighState.value;
        this.alarmHigh = cloneDeep(this.alarmHigh);
      }
      const matchAlarmLowState = statesData.find(s => s.id === get(this.alarmLow, 'id'));
      if (matchAlarmLowState) {
        this.alarmLow.value.value = matchAlarmLowState.value;
        this.alarmLow = cloneDeep(this.alarmLow);
      }
    }
  }
};